import React from 'react';
import './App.css';

import Navbar from './components/Navbar';
import Game from './components/Game';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Game/>
    </div>
  );
}

export default App;